import { ArrowLeftOutlined, HomeOutlined } from "@ant-design/icons"
import { Button, Space } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"

import Images from "../../Images"
import { RoutesPaths } from "../../constants/routes"
import { type RootState } from "../../store"
import type { AuthState } from "../LoginPage/redux/auth.type"
import "./styles.less"

interface NotFoundPageProps {
  auth: AuthState
}

function NotFoundPage(props: NotFoundPageProps) {
  const { auth } = props
  const { t } = useTranslation()
  const navigate = useNavigate()
  // A link opened in a new tab has nothing to go back to.
  const canGoBack = useLocation().key !== "default"

  const signedIn = !!auth?.accessToken
  // Kept from the old link: an admin or a user still onboarding goes through
  // the sign-in route, which forwards a signed-in user to their own landing.
  const homeRoute =
    signedIn && auth?.userInfo?.onboarding_finished && !auth?.isAdmin
      ? RoutesPaths.home
      : RoutesPaths.auth.login

  return (
    <div className="not-found">
      <img src={Images.logo} alt="" />
      <div className="not-found-content">
        <div>404</div>
        <p>{t("notFoundPage.title")}</p>
        <p>{t("notFoundPage.hint")}</p>
        <Space wrap>
          <Button
            type={"primary"}
            icon={<HomeOutlined />}
            onClick={() => navigate(homeRoute)}
          >
            {t(signedIn ? "notFoundPage.home" : "notFoundPage.signIn")}
          </Button>
          {canGoBack && (
            <Button icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)}>
              {t("notFoundPage.back")}
            </Button>
          )}
        </Space>
      </div>
    </div>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps)(NotFoundPage)
